module.exports = {
    EMAIL_MAX_LENGTH: 40
};


// WEBPACK FOOTER //
// ./app/scripts/constants/app.js